const ROUTER_ENDPOINT = 'https://router.janis.in/api/endpoint';
const HOST_ENDPOINT = 'https://janis.in/view';
const CDN_HOST = 'https://cdn.janis.in';
const I18N_CDN_HOST = 'https://cdn.i18n.janis.in';
const SCHEMA_ENDPOINT = 'https://app.janis.in';
const DOMAIN = '.janis.in';

export { ROUTER_ENDPOINT, HOST_ENDPOINT, CDN_HOST, I18N_CDN_HOST, SCHEMA_ENDPOINT, DOMAIN };
